import { requestWithTimeout } from './customFetch';
import { getApiKey } from './loqateApiKeys';

const searchUrl = 'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws';
const retrieveUrl = 'https://api.addressy.com/Capture/Interactive/Retrieve/v1/json3.ws';

export const SEARCH_RESULT_TYPE_ADDRESS = 'Address';

interface LoqateError {
  Cause: string;
  Description: string;
  Error: string;
  Resolution: string;
}

export interface AddressSearchResult {
  Description: string;
  Highlight: string;
  Id: string;
  Text: string;
  Type: string;
}

export interface RetrieveResult {
  City: string;
  Company: string | undefined;
  CountryIso2: string;
  Line1: string | undefined;
  Line2: string | undefined;
  PostalCode: string;
  ProvinceName: string;
}

interface AddressSearchResponse {
  Items: LoqateError[] | AddressSearchResult[];
}

interface RetrieveResponse {
  Items: LoqateError[] | RetrieveResult[];
}

const responseIsSearchResult = (
  items: AddressSearchResult[] | LoqateError[],
): items is AddressSearchResult[] => {
  return items.length === 0 || (items as AddressSearchResult[])[0].Id !== undefined;
};

const responseIsRetrieveResult = (
  items: RetrieveResult[] | LoqateError[],
): items is RetrieveResult[] => {
  return items.length === 0 || (items as RetrieveResult[])[0].Line1 !== undefined;
};

export const search = async (
  query: string,
  container: string,
  country: string,
): Promise<AddressSearchResult[]> => {
  const params = {
    Key: getApiKey(country),
    Text: query,
    Container: container,
    Countries: country,
  };
  const url = `${searchUrl}?${new URLSearchParams(params).toString()}`;
  const response: AddressSearchResponse = await requestWithTimeout(url);

  if (responseIsSearchResult(response.Items)) {
    return response.Items as AddressSearchResult[];
  }
  throw new Error(`Address search error: ${response.Items[0].Description}`);
};

export const retrieve = async (addressId: string, country: string): Promise<RetrieveResult[]> => {
  const params = {
    Key: getApiKey(country),
    Id: addressId,
  };
  const url = `${retrieveUrl}?${new URLSearchParams(params).toString()}`;
  const response: RetrieveResponse = await requestWithTimeout(url.toString());

  if (responseIsRetrieveResult(response.Items)) {
    return response.Items as RetrieveResult[];
  }
  throw new Error(`Address retrieve error: ${response.Items[0].Description}`);
};
